import type React from 'react';
import { useTranslation } from 'react-i18next';
import type { EmployeeStatus } from '@/api/models';
import { cn } from '@/utils/cnUtils';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import { EMPLOYEE_STATUS_CHIP } from '../../salariesMeta';

type EmployeeStatusChipProps = {
    status: EmployeeStatus;
    /** Row discriminator, appended after the literal testid prefix. */
    slot: string;
};

/**
 * Active / Terminated, in the journal's calm vocabulary. Leaving is a normal end
 * of an employment, so Terminated is muted and settled — never danger.
 */
export const EmployeeStatusChip: React.FC<EmployeeStatusChipProps> = ({
    status,
    slot,
}) => {
    const { t } = useTranslation('pages');
    const chip = EMPLOYEE_STATUS_CHIP[status];

    return (
        <span
            className={cn(
                'inline-flex w-fit items-center rounded-lg px-2.5 py-1 text-xs font-medium',
                chip.className,
            )}
            {...getNodeTestIdProp(`salaries-status-chip-${slot}`)}
        >
            {t(chip.labelKey)}
        </span>
    );
};
